import { Injectable } from '@angular/core';
import { DynamicLayoutItemSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-item-settings';
import { DynamicLayoutSettings } from '@common-modules/dynamic-layout/models/dynamic-layout-settings';
import { PermissionsRequest } from '@common-modules/shared/auth/models/permissions-request';
import { Observable } from 'rxjs';
import { DashboardDefinition } from './dashboard-definition';
import { DashboardGroupDefinition } from './dashboard-group-definition';
import { DashboardIdentity } from './dashboard-identity';
import { DashboardsService } from './dashboards.service';

@Injectable()
export class DefaultDashboardsService extends DashboardsService {
  createDashboardChildWidget(): Observable<DynamicLayoutItemSettings> {
    throw new Error('Method not implemented.');
  }
  mapLayoutToDashboardGroup(
    dynamicLayoutSettings: DynamicLayoutSettings,
  ): DashboardGroupDefinition {
    throw new Error('Method not implemented.');
  }
  mapDashboardGroupToLayout(dashboardGroup: DashboardGroupDefinition): DynamicLayoutSettings {
    throw new Error('Method not implemented.');
  }
  createGroup(dashboardGroup: DashboardGroupDefinition): Observable<DashboardGroupDefinition> {
    throw new Error('Method not implemented.');
  }
  updateGroup(dashboardGroup: DashboardGroupDefinition): Observable<DashboardGroupDefinition> {
    throw new Error('Method not implemented.');
  }
  loadGroup(): Observable<DashboardGroupDefinition> {
    throw new Error('Method not implemented.');
  }
  createDashboard(dashboard: DashboardIdentity): Observable<DashboardIdentity> {
    throw new Error('Method not implemented.');
  }
  updateDashboard(dashboard: DashboardDefinition): Observable<DashboardDefinition> {
    throw new Error('Method not implemented.');
  }
  loadDashboard(dashboard: DashboardIdentity): Observable<DashboardDefinition> {
    throw new Error('Method not implemented.');
  }
  getDashboardsGroupPermissions(): Observable<PermissionsRequest> {
    throw new Error('Method not implemented.');
  }
}
